import { formatTelepon } from "./phone";
export function rupiah(n) {
  const v = Math.round(Number(n) || 0);
  return "Rp" + v.toLocaleString("id-ID");
}

export function angka(n) {
  return (Number(n) || 0).toLocaleString("id-ID");
}

export function tanggal(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      timeZone: "Asia/Jakarta",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const KATEGORI_LABEL = { SEAL: "Seal", PLASTIK: "Plastik" };

export function alamatBaris(a) {
  if (!a) return "";
  return [a.jalan, a.kelurahan, a.kecamatan, a.kota, a.provinsi, a.kode_pos]
    .map((x) => (x || "").trim())
    .filter(Boolean)
    .join(", ");
}

// "Ditagihkan kepada" — baris terstruktur tanpa pengulangan / koma menggantung.
export function ditagihkanBaris(order) {
  const a = order?.alamat_kirim || {};
  const nama = (a.nama_penerima || order?.pelanggan_nama || "").trim();
  const usaha = (order?.pelanggan_usaha || "").trim();
  const lines = [];
  if (nama) lines.push({ text: nama, bold: true });
  if (usaha && usaha.toLowerCase() !== nama.toLowerCase()) lines.push({ text: usaha });
  const tel = formatTelepon((a.telepon || "").trim());
  if (tel) lines.push({ text: tel });
  const jalan = (a.jalan || "").trim();
  if (jalan) lines.push({ text: jalan });
  const l5 = [a.kelurahan, a.kecamatan].map((x) => (x || "").trim()).filter(Boolean).join(", ");
  if (l5) lines.push({ text: l5 });
  const l6 = [a.kota, a.provinsi, a.kode_pos].map((x) => (x || "").trim()).filter(Boolean).join(", ");
  if (l6) lines.push({ text: l6 });
  return lines;
}

export const STATUS_LABEL = {
  MENUNGGU_BAYAR: "Menunggu Bayar",
  MENUNGGU_KONFIRMASI: "Menunggu Konfirmasi",
  DIPROSES: "Diproses",
  DIBAYAR: "Diproses",
  DIKEMAS: "Diproses",
  DIKIRIM: "Dikirim",
  SELESAI: "Selesai",
  BATAL: "Batal (belum bayar)",
  DIBATALKAN: "Dibatalkan/Retur (setelah bayar)",
};

export const STATUS_ORDER = ["MENUNGGU_BAYAR", "DIPROSES", "DIKIRIM", "SELESAI"];

// Hitungan harga bertingkat di browser (effectiveUnitPrice / categoryPercent / nextTier) DIHAPUS (Petunjuk-harga 1, Haryanto 25/10/2026):
// halaman produk memakai GET /api/products/:id/petunjuk-harga (server, fungsi checkout).

